<template>
	<GalleryComponent :pictureData="layoutData" :index="index" :pictureKey="pictureKey" isMultiblock="false" />
</template>

<script>

import GalleryComponent from "./GalleryComponent.vue";

export default {
	components: {
		GalleryComponent
	},
	props: {
		layoutData: {
			type: Object
		},
		index: {
			type: Number
		},
		pictureKey: {
			type: Object
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.container-layout {
	.gallery-wrapper {
		.gallery { 
			img {
				height: 100%;
				object-fit: contain;
				width: 100%;
			}
		}
	}
}
</style>